import React from 'react';

import { Navigate } from 'react-router-dom';
import { isLoggin, isShop } from '../util/IsLoggin';

const MyRoute = ({
  component: Component,
  isRestricted = false,
  needShop = false,
}) => {
  if (needShop && !isShop()) {
    return <Navigate to='/setting' replace />;
  }

  if ((isRestricted || !needShop) && !isLoggin()) {
    return <Navigate to='/login' replace />;
  }

  return <Component />;
};

export default MyRoute;
